module.exports = __webpack_public_path__ + "img/End_screen.f0d03830.gif";